import { render } from "./MessageProcessing.vue?vue&type=template&id=bcbfbcee"
import script from "./MessageProcessing.vue?vue&type=script&lang=js"
export * from "./MessageProcessing.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__